import { MODE } from '../constants';
import { FEATURE_FLAGS } from '../constants/feature-flags';
import { useModeContext } from './contexts/mode-context';
import { useSplitTreatment } from './split-treatment';

/**
 * @deprecated This hook is deprecated. It exists for backwards compatibility purposes
 * and MUST NOT be utilized in any new place in the app.
 * It will be removed after migrating to Blueprint components in FileRequest.
 * FORMS-16628
 */
export const useShouldRenderBlueprint = (
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
  passedMode: string | null = undefined,
) => {
  const { mode } = useModeContext();
  let usedMode = mode;
  if (passedMode) {
    usedMode = passedMode;
  }
  const isFileRequestBlueprintEnabled = useSplitTreatment(
    FEATURE_FLAGS.FORMS_FILE_REQUEST_BLUEPRINT,
  );

  if (usedMode === MODE.FORM) {
    return true;
  }
  if (usedMode === MODE.FILE_REQUEST) {
    return isFileRequestBlueprintEnabled;
  }

  return false;
};
